import { Component, Input, OnInit } from '@angular/core';
import { Kontrolltermin } from '../../../services/kontrolltermin.service';

@Component({
  selector: 'app-header-info',
  templateUrl: './header-info.component.html',
  styleUrls: ['./header-info.component.scss']
})
export class HeaderInfoComponent implements OnInit {
  @Input() kontrolltermin!: Kontrolltermin;
  @Input() editableFields: string[] = [];
  @Input() showTimeFields: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

  isFieldEditable(field: string): boolean {
    return this.editableFields.includes(field);
  }
}